module.exports = __webpack_public_path__ + "media/images/announceGroup__icon-c6740ec14bdc3b6bcc89804bd01a7921.png";